export function mixedSlider() {

    let $curSlider = $(".mixed-slider");
    let slidesLength = $curSlider.find(".image").length;
    let $accordionButtons = $(".accordion > .item > h4");

    if (slidesLength > 1) {
        $curSlider.slick({
            fade: true,
            infinite: false,
            dots: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            draggable: false,
        });
    }

    $accordionButtons.on("click", function () {
        let $this = $(this);
        let slideNumber = $this.closest(".item").attr("data-controll-img");
        $curSlider.slick("slickGoTo", slideNumber);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mixedSlider.js